const getConfig = () => {
  const ID = process.env.REACT_APP_PIXEL_FACEBOOK_ID ?? "2538871009718963";
  return ID;
};

const loadFacebookPixelScript = () => {
  if (window.fbq) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script");
};

export const init = () => {
  const id = getConfig();
  loadFacebookPixelScript();
  if (window.fbq) {
    window.fbq("init", id);
    window.fbq("track", "PageView");
  }
};

export const trackPageView = () => {
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
};

export const trackEvent = (event, data = {}) => {
  if (window.fbq) {
    window.fbq("track", event, data);
  }
};

export const trackSingle = (event, data = {}) => {
  const id = getConfig();
  if (window.fbq) {
    window.fbq("init", id); // ensure pixel is initialized
    window.fbq("track", event, data);
  }
};

export const trackCustom = (event, data = {}) => {
  if (window.fbq) {
    window.fbq("trackCustom", event, data);
  }
};

export const trackSingleCustom = (event, data = {}) => {
  const id = getConfig();
  if (window.fbq) {
    window.fbq("init", id);
    window.fbq("trackCustom", event, data);
  }
};
